import { store } from "@redux"
import haveAuth from "./haveAuth"

const isOrderForThisUser = (order) => {
  if (!order) return false

  const { userAccountInfo } = store.getState()

  const isCashierInOrderBranch =
    userAccountInfo.cashierBranches.some(cb =>
      cb.branchId === order.branchId
    )

  if (!isCashierInOrderBranch) return false

  if (
    !haveAuth(["viewOtherAccessesOrders"]) &&
    order.addedByAccountId !== userAccountInfo._id
  )
    return false

  return true
}

export default isOrderForThisUser